import React from "react";

const Stat_Frequency_Tables = () => {
  return (
    <div>
      <h1>Stat Frequency Tables</h1>
    </div>
  );
};

export default Stat_Frequency_Tables;
